import { useEffect } from 'react'
import { useRouter } from 'next/router'
import cogoToast from 'cogo-toast'
import nookies from 'nookies'
import Spinner from '@components/common/spinner'
import { AUTHORIZED_ONLY_ENDPOINTS } from 'common/constants'
import { hasRoute } from '@common/utils'

const LogoutHandler = () => {
  const router = useRouter()
  const { next } = router.query

  const handleRedirect = () => {
    const redirectUrl = next || '/'
    if (hasRoute(redirectUrl.toString(), AUTHORIZED_ONLY_ENDPOINTS)) {
      router.push('/')
    } else {
      router.push(redirectUrl.toString())
    }
  }

  useEffect(() => {
    nookies.destroy(null, 'token', { path: '/' })
    handleRedirect()
    cogoToast.info('Logged out successfully')
  }, [])

  // We send user data to chatwoot when user logs-in. We must
  // reset the widget when the user logs-out.
  useEffect(() => {
    const handleResetChatwootWidgetSession = () => window.$chatwoot?.reset()
    window.addEventListener('chatwoot:ready', handleResetChatwootWidgetSession)
    return () =>
      window.removeEventListener(
        'chatwoot:ready',
        handleResetChatwootWidgetSession
      )
  }, [])

  return (
    <div className="flex items-center justify-center h-screen w-full">
      <Spinner classes="h-10 w-10 text-orange" />
    </div>
  )
}

export default LogoutHandler
